import Vue from 'vue'
import VueRouter, { NavigationGuard, RouterOptions } from 'vue-router'
import { Store } from 'vuex/types'
import { IRootState } from '@/store'
import types from '@/store/all-action-types' 


import MenuCompte from '@/components/compte/MenuCompte.vue'

Vue.use(VueRouter)

const routes =  [
    {  
      path: '/', 
      name: 'Home', 
      component: () => import(/* webpackChunkName: "aquadomic" */ '@/views/pages/Home.vue'),
    },
    {  
      path: '/reserver', 
      name: 'Reserver', 
      component: () => import(/* webpackChunkName: "reserver" */ '@/views/pages/Reserver.vue'),
    },     
    {
      path: '/piscines',        
      component:  () => import(/* webpackChunkName: "piscines" */ '@/views/pages/piscines/index.vue'),
      children:[
        {
          path: '',
          name: 'Piscines',
          component:  () => import(/* webpackChunkName: "piscines" */ '@/views/pages/piscines/Piscines.vue'),  
          props(route: any) {              
            return { ...route.params, activityId:parseInt(route?.params?.activityId ?? -1)}
          },         
        },
        { 
          path: ':slug',
          name: 'DetailPiscine',
          component: () => import(/* webpackChunkName: "piscines" */ '@/views/pages/piscines/DetailPiscine.vue'),
          props(route: any) {              
            return { ...route.params, piscineId:parseInt(route?.params?.piscineId ?? -1)}
          },
        }
      ]        
    },      
    {
      path: '/activites-enfants',        
      component:  () => import(/* webpackChunkName: "activites-enfants" */ '@/views/pages/activites/index.vue'),
      children:[
        {
          path: '',
          name: 'Enfants',
          component:  () => import(/* webpackChunkName: "activites-enfants" */ '@/views/pages/activites/Enfants.vue'),           
        }, 
        {
          path: ':slug',
          name: 'ActiviteEnfant',
          component:  () => import(/* webpackChunkName: "activites-enfants" */ '@/views/pages/activites/DetailActivite.vue'),
          props(route: any) {              
            return { ...route.params, activityId:parseInt(route?.params?.activityId ?? -1) }
          },          
        }
      ]        
    },      
    {
      path: '/activites-adultes',        
      component:  () => import(/* webpackChunkName: "activites-adultes" */ '@/views/pages/activites/index.vue'),
      children:[
        {
          path: '',
          name: 'Adultes',
          component:  () => import(/* webpackChunkName: "activites-adultes" */ '@/views/pages/activites/Adultes.vue'),          
        },
        {
          path: ':slug',
          name: 'ActiviteAdulte',
          component:  () => import(/* webpackChunkName: "activites-enfants" */ '@/views/pages/activites/DetailActivite.vue'),
          props(route: any) {              
            return { ...route.params, activityId:parseInt(route?.params?.activityId ?? -1) }
          },          
        }
      ]        
    },      
    {
      path: '/blog',        
      component:  () => import(/* webpackChunkName: "blog" */ '@/views/pages/blog/index.vue'),
      children:[
        {
          path: '',
          name: 'Blog',
          component:  () => import(/* webpackChunkName: "blog" */ '@/views/pages/blog/Blog.vue'),          
        },
        {
          path: ':name',
          name: 'Debutant',
          component: () => import(/* webpackChunkName: "blog" */ '@/views/pages/blog/Article.vue'),
        }
      ]        
    },
    {
      path: '/domicile',
      name: 'Domicile',
      component: () => import(/* webpackChunkName: "domicile" */ '@/views/pages/domicile/Domicile.vue'),
    },
    {
      path: '/visio',
      name: 'Visio',
      component: () => import(/* webpackChunkName: "visio" */ '@/views/pages/domicile/Visio.vue'),
    },
    {  
      name: 'MentionsLegales', path: '/mentions-legales', 
      component: () => import(/* webpackChunkName: "annexes" */ '@/views/pages/annexes/MentionsLegales.vue'),
    }, 
    {  
      name: 'ConditionsGeneralesVente', path: '/cgv', 
      component: () => import(/* webpackChunkName: "annexes" */ '@/views/pages/annexes/ConditionsGeneralesVente.vue'),
    },         
    {  
      name: 'Contact', path: '/contact', 
      component: () => import(/* webpackChunkName: "aquadomic" */ '@/views/pages/annexes/Contact.vue'),
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "aquadomic" */ '@/views/Login.vue'),
    },
    {
      path: '/create-password',
      name: 'CreatePassword',
      component: () => import(/* webpackChunkName: "aquadomic" */ '@/views/CreatePassword.vue')
    },
    {
      path: '/profil',        
      component: () => import(/* webpackChunkName: "profil" */ '@/views/back/profil/index.vue'),
      meta: {        
        hideFooter: true         
      },
      children:[
        { 
          path: '',
          name: 'ProfilAccount',
          component: () => import(/* webpackChunkName: "profil" */ '@/views/back/profil/ProfilAccount.vue'),
          meta: {                        
            drawerCmp: 'menu-administration',            
            roles:["Client"]
          },
        }, 
        {
          path: 'panier',
          name: 'Cart',
          component: () => import(/* webpackChunkName: "profil" */ '@/views/back/profil/Panier.vue'),          
          meta: {        
            hideFooter: false 
          },
        },                      
        {
          path: 'facturation',
          name: 'Billing',
          component: () => import(/* webpackChunkName: "profil" */ '@/views/back/profil/Panier.vue'),          
          props(route: any) {              
            return { ...route.params, initialStep:2}
          },
          meta: {        
            hideFooter: false 
          },
        },             
        {
          path: 'paiement',
          name: 'Checkout',
          component: () => import(/* webpackChunkName: "profil" */ '@/views/back/profil/Panier.vue'),          
          props(route: any) {              
            return { ...route.params, initialStep:3}
          },
          meta: {        
            hideFooter: false 
          },
        },    
        {
          path: 'administration',                 
          component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/index.vue'),
          meta: {
            drawerCmp: 'menu-administration',
            hideFooter: true         
          },
          children:[
            {
              path: '',
              name: 'Dashboard',
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/Dashboard.vue'),
              meta: {
                drawerCmp: 'menu-administration'          
              }
            },
            {
              path: 'contacts', 
              name: 'AdminContact',
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/contact/GestionContact.vue'),
              meta: {            
                drawerCmp: 'menu-administration',
                roles:["Admin"]
              }
            },  
            {
              path: 'contacts/:contactId',
              name: 'ModifyContact',  
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/contact/ModifyContact.vue'),
              props(route: any) {              
                return { ...route.params, contactId:parseInt(route?.params?.contactId ?? -1)  }
              },
              meta: {
                drawerCmp: 'menu-administration',
                roles:["Admin"]
              }
            },
            {
              path: 'newsletters', 
              name: 'AdminNewsletter',
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/newsletter/GestionNewsletter.vue'),
              meta: {            
                drawerCmp: 'menu-administration',
                roles:["Admin"]
              }
            },
            {
              path: 'piscines', 
              name: 'AdminPiscine',
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/piscine/GestionPiscine.vue'),
              meta: {            
                drawerCmp: 'menu-administration',
                roles:["Admin"]
              }
            },  
            {
              path: 'piscines/:piscineId',
              name: 'ModifyPiscine',  
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/piscine/ModifyPiscine.vue'),
              props(route: any) {              
                return { ...route.params, piscineId:parseInt(route?.params?.piscineId ?? -1)  }
              },
              meta: {
                drawerCmp: 'menu-administration',
                roles:["Admin"]
              }
            },
            {
              path: 'activites',
              name: 'AdminActivity',
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/activity/GestionActivity.vue'),
              meta: {
                drawerCmp: 'menu-administration',
                roles:["Admin"]
              }
            }, 
            {
              path: 'activites/:activityId',
              name: 'ModifyActivity', 
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/activity/ModifyActivity.vue'),
              props(route: any) {              
                return { ...route.params, activityId:parseInt(route?.params?.activityId ?? -1)  }
              },
              meta: {
                drawerCmp: 'menu-administration',
                roles:["Admin"]
              }
            },
            {
              path: 'forfaits',
              name: 'AdminForfait',
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/forfait/GestionForfait.vue'),
              meta: {
                drawerCmp: 'menu-administration',
                roles:["Admin"]
              }
            }, 
            {
              path: 'forfaits/:forfaitId',
              name: 'ModifyForfait', 
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/forfait/ModifyForfait.vue'),
              props(route: any) {              
                return { ...route.params, forfaitId:parseInt(route?.params?.forfaitId ?? -1)  }
              },
              meta: {
                drawerCmp: 'menu-administration',
                roles:["Admin"]
              }
            },    
            {
              path: 'familles',
              name: 'AdminFamily',
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/family/GestionFamily.vue'),
              meta: {
                drawerCmp: 'menu-administration',
                roles:["Admin"]
              }
            }, 
            {
              path: 'familles/:familyId',
              name: 'ModifyFamily', 
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/family/ModifyFamily.vue'),
              props(route: any) {              
                return { ...route.params, familyId:parseInt(route?.params?.familyId ?? -1)  }
              },
              meta: {
                drawerCmp: 'menu-administration',
                roles:["Admin"]
              }
            },            
            {
              path: 'pages',
              name: 'AdminPages',
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/pages/ListPages.vue'),
              meta: {
                drawerCmp: 'menu-administration'          
              }
            },
            {
              path: 'blog',
              name: 'AdminArticles',
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/blog/ListArticles.vue'),
              meta: {
                drawerCmp: 'menu-administration'          
              }
            },
            {
              path: 'medias',
              name: 'AdminMedias',
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/mediatheque/ListMedias.vue'),
              meta: {
                drawerCmp: 'menu-administration'          
              }
            },
            {
              path: 'cours', 
              name: 'AdminCours',
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/cours/ListCours.vue'),
              meta: {
                drawerCmp: 'menu-administration'          
              }
            },
            {
              path: 'mns',
              name: 'AdminMns',
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/mns/ListMns.vue'),
              meta: {
                drawerCmp: 'menu-administration'          
              }
            },
            {
              path: 'commandes',
              name: 'AdminCommande',
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/commande/GestionCommande.vue'),
              meta: {
                drawerCmp: 'menu-administration'          
              }
            },
            {
              path: 'commandes/:commandeId',
              name: 'ModifyCommande', 
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/commande/ModifyCommande.vue'),
              props(route: any) {              
                return { ...route.params, commandeId:parseInt(route?.params?.commandeId ?? -1)  }
              },
              meta: {
                drawerCmp: 'menu-administration',
                roles:["Admin"]
              }
            },     
            {
              path: 'templates', 
              name: 'AdminMailTemplate',
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/mailTemplate/GestionMailTemplate.vue'),
              meta: {
                drawerCmp: 'menu-administration'          
              }
            },
            {
              path: 'skins',
              name: 'AdminMailSkin',
              component: () => import(/* webpackChunkName: "administration" */ '@/views/back/administration/mailSkin/GestionMailSkin.vue'),
              meta: {
                drawerCmp: 'menu-administration'          
              }
            }
          ]
        },        
        {
          path: 'password',
          name: 'ChangePassword',
          component: () => import(/* webpackChunkName: "profil" */ '@/views/back/profil/ChangePassword.vue'),
          meta: {            
          }
        },
        {
          path: 'my-booking',
          name: 'MyBooking',
          component: () => import(/* webpackChunkName: "profil" */ '@/views/back/profil/MyBooking.vue'),
          meta: {            
          }
        },
        {
          path: 'session-history',
          name: 'SessionHistory',
          component: () => import(/* webpackChunkName: "profil" */ '@/views/back/profil/SessionHistory.vue'),
          meta: {                  
          }
        },
        {
          path: 'commandes',
          name: 'Command',
          component: () => import(/* webpackChunkName: "profil" */ '@/views/back/profil/Command.vue'),
          meta: {
            
          }
        }
        
        
      ]
    }
  ]

  
export default (store: Store<IRootState>) => {
  
  //@ts-ignore
const router = new VueRouter({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  //mode: 'history',
  //@ts-ignore
  routes
})

//mise ne place de la securité test pour chaque route demandée
router.beforeEach(((to, from, next) => {            
  if((to.meta?.roles?.length ?? 0) > 0 ) {      
    if(store.getters.canAccess(to.meta?.roles)) {            
      next()
      return
    }  
    else {        
      store.dispatch(types.AUTH_SET_REDIRECT_PATH, to.path)
      next({name:'Login'})        
      return
    }    
  }     
  else {
    next()
    return
  }

}) as NavigationGuard) 

return router
}